module.exports = __webpack_public_path__ + "media/dashboard/assets/tutorials/guia-interativa-329cb5b879022bd74c7e6acf964ef777.gif";